import {
  getUserAnalyticsObject,
  sanitizeTextForAnalytics,
} from "@/utils/helper"
import {
  ADD_TO_CART,
  COLOR_SELECTION,
  INCLUDE_SELECT,
  SILDER_BUNDLE_IMAGE_CLICK,
  PDP,
  PRODUCT_DETAILS,
  BUNDLE,
  SHARE,
  PRINT,
  BREADCRUMB,
  STICKY_NAV,
  HEADER,
  SPECS,
  VIEW_MORE,
  MOUSEOVER,
  ACCORDIAN,
} from "@/components/MultiFinshProductBundle/analytics/constants"

export const loadCmpShowEvent = data => {
  const {
    productInfoBundle: productInfo = [],
    siteName = "kohler",
    category = "",
    sku = "",
    cmpShowAnlyticsTimer = null,
  } = data

  const initialColor = productInfo?.[0]?.bundleProductColors || ""
  const initialPrice = productInfo?.[0]?.bundlePrice || 0

  if (
    !productInfo ||
    productInfo.length === 0 ||
    !initialColor ||
    initialPrice === 0
  ) {
    return null
  }

  const categoryName = sanitizeTextForAnalytics(category)
  const fullSku = sanitizeTextForAnalytics("K-" + sku)

  const page = window.pageObj || {}
  const pageCategory = window.pageObj?.category || {}
  const pageType = pageCategory?.pageType || ""

  pageCategory["productLocalCategory"] = categoryName
  pageCategory["room"] = "n/a" // TODO: need to get the primary category, no data available in the api response
  pageCategory["subCategory1"] = pageType + ":" + categoryName
  pageCategory["subCategory2"] = pageType + ":" + categoryName + ":" + fullSku
  pageCategory["subCategoryID"] = fullSku
  pageCategory["subCategoryName"] = categoryName

  const { pageInfo: { contentType = "pdp" } = {} } = page
  const pageInfo = window.pageObj?.pageInfo || {}
  pageInfo["pageName"] = sanitizeTextForAnalytics(
    `${siteName}:${contentType || "pdp"}:${categoryName}:${fullSku}`
  )

  pageInfo["imageId"] = "n/a"
  pageInfo["resourceType"] = "imgitemiso"
  pageInfo["defaultImage"] = "n/a"
  pageInfo["title"] = sanitizeTextForAnalytics(pageInfo["title"])

  page.category = pageCategory
  page.user = getUserAnalyticsObject()
  page.productInfo = [...productInfo]

  if (window?.needPdpdata) {
    delete window.needPdpdata
  }

  if (
    (!page.user.gId || page.user.gId === "n/a") &&
    (!page.user.commerceToolsID || page.user.commerceToolsID === "n/a")
  ) {
    page.pageInfo = pageInfo
    window.pageObj = page
    window.isShowAnalyticsEvent = true
  } else {
    window.adobeDataLayer.push({
      event: "cmp:show",
      pageInfo,
      productInfo,
      page,
    })
    clearInterval(cmpShowAnlyticsTimer)
  }
}

export const bundleAddToCartAnalytics = productInfo => {
  const eventInfo = {
    eventAction: `${PDP}:${PRODUCT_DETAILS}:${ADD_TO_CART}`,
    eventMsg: "n/a",
    eventName: `${PDP}:${PRODUCT_DETAILS}:${ADD_TO_CART}`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: ADD_TO_CART,
    internalLinkPosition: `${PDP}:${BUNDLE}`,
    internalLinkType: `${PDP}:${ADD_TO_CART}`,
    clickInternalLinks: "true",
    internalLinkURL: "n/a",
    internalLinkZoneName: `${PDP}:${PRODUCT_DETAILS}`,
    modalName: BUNDLE,
  }

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const colorSelectorAnalytics = productInfo => {
  const eventInfo = {
    eventAction: `${PDP}:${PRODUCT_DETAILS}:${COLOR_SELECTION}`,
    eventMsg: "n/a",
    eventName: `${PDP}:${PRODUCT_DETAILS}:${COLOR_SELECTION}`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: COLOR_SELECTION,
    internalLinkPosition: `${PDP}:${BUNDLE}`,
    internalLinkType: `${PDP}:${COLOR_SELECTION}`,
    clickInternalLinks: "true",
    internalLinkURL: "n/a",
    internalLinkZoneName: `${PDP}:${PRODUCT_DETAILS}`,
    modalName: BUNDLE,
  }

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const productOptionSelectorAnalytics = (productInfo, optionCategory) => {
  const eventInfo = {
    eventAction: `${PDP}:${PRODUCT_DETAILS}:${optionCategory}`,
    eventMsg: "n/a",
    eventName: `${PDP}:${PRODUCT_DETAILS}:${optionCategory}`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: optionCategory,
    internalLinkPosition: `${PDP}:${BUNDLE}`,
    internalLinkType: `${PDP}:product selection`,
    clickInternalLinks: "true",
    internalLinkURL: "n/a",
    internalLinkZoneName: `${PDP}:${PRODUCT_DETAILS}`,
    modalName: BUNDLE,
  }

  pushAnalyticsObjToDataLayer(eventInfo, [productInfo])
}

export const selectedProductListAnalytics = (productInfo, accordianAction) => {
  const eventInfo = {
    eventAction: `${PDP}:${PRODUCT_DETAILS}:${INCLUDE_SELECT}${accordianAction}`,
    eventMsg: "n/a",
    eventName: `${PDP}:${PRODUCT_DETAILS}:${INCLUDE_SELECT}${accordianAction}`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: `${INCLUDE_SELECT}${accordianAction}`,
    internalLinkPosition: `${PDP}:${BUNDLE}`,
    internalLinkType: `${PDP}:${INCLUDE_SELECT}${accordianAction}`,
    clickInternalLinks: "true",
    internalLinkURL: "n/a",
    internalLinkZoneName: `${PDP}:${PRODUCT_DETAILS}`,
    modalName: BUNDLE,
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const navigationAnalytics = (productInfo, slideDirection) => {
  const eventInfo = {
    eventAction: `${PDP}:${PRODUCT_DETAILS}:${SILDER_BUNDLE_IMAGE_CLICK}:${slideDirection}`,
    eventMsg: "n/a",
    eventName: `${PDP}:${PRODUCT_DETAILS}:${SILDER_BUNDLE_IMAGE_CLICK}:${slideDirection}`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: `${slideDirection} arrow`,
    internalLinkPosition: `${PDP}:${BUNDLE}`,
    internalLinkType: `${PDP}:${slideDirection} arrow`,
    clickInternalLinks: "true",
    internalLinkURL: "n/a",
    internalLinkZoneName: `${PDP}:${PRODUCT_DETAILS}`,
    modalName: BUNDLE,
  }

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const bundleAddToCartFromStickyAnalytics = productInfo => {
  const eventInfo = {
    eventAction: `pdp:${STICKY_NAV}:${ADD_TO_CART}`,
    eventMsg: "n/a",
    eventName: `pdp:${STICKY_NAV}:${ADD_TO_CART}`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: ADD_TO_CART,
    internalLinkPosition: `pdp:bundle:${HEADER}`,
    internalLinkType: `pdp:${ADD_TO_CART}`,
    clickInternalLinks: "true",
    internalLinkURL: "n/a",
    internalLinkZoneName: `pdp:${STICKY_NAV}`,
    modalName: "bundle",
  }

  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const accordianClickBundleFeature = (
  title = "",
  accordianState = "",
  productInfoBundle = {}
) => {
  const eventInfo = {
    eventAction: `pdp:${PRODUCT_DETAILS}:${ACCORDIAN} ${accordianState}`,
    eventName: `pdp:${PRODUCT_DETAILS}:${ACCORDIAN} ${accordianState}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: accordianState,
    internalLinkPosition: "pdp:bundle",
    internalLinkType: `pdp:${title}`,
    internalLinkZoneName: `pdp:${PRODUCT_DETAILS}`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    modalName: "bundle",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfoBundle)
}

export const viewMoreBundleFeature = (url = "", productInfoBundle = {}) => {
  const eventInfo = {
    eventAction: `pdp:${SPECS}:${VIEW_MORE}`,
    eventName: `pdp:${SPECS}:${VIEW_MORE}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: `${VIEW_MORE}`,
    internalLinkPosition: "pdp:bundle",
    internalLinkType: `pdp:${SPECS}:${VIEW_MORE}`,
    internalLinkZoneName: `pdp:${SPECS}`,
    internalLinkURL: `${window.location.origin}${url}`,
    clickInternalLinks: "true",
    modalName: "bundle",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfoBundle)
}

export const dimensionsTooltipAnalyticsData = (
  type = "",
  message = "",
  productInfoBundle = {}
) => {
  const title = type.toLowerCase().trim()
  const eventInfo = {
    eventAction: `pdp:${PRODUCT_DETAILS}:${title} ${MOUSEOVER}`,
    eventName: `pdp:${PRODUCT_DETAILS}:${title} ${MOUSEOVER}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: message?.toLocaleLowerCase(),
    internalLinkPosition: "pdp:bundle",
    internalLinkType: `pdp:${MOUSEOVER}:${title}`,
    internalLinkZoneName: `pdp:${PRODUCT_DETAILS}`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
    modalName: "bundle",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfoBundle)
}

export const addAnlyticsForSDownloadSpec = (
  title = "",
  selectedFileList = [],
  techFils = [],
  mainTitle = "",
  productInfoBundle = {}
) => {
  const techFilsLists = techFils.map(selectedObj => selectedObj.toLowerCase())
  const eventInfo = {
    eventAction: `pdp:${mainTitle}:${title}`,
    eventName: `pdp:${mainTitle}:${title}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "success",
    internalLinkName: `${title}|${selectedFileList.join(":").toLowerCase()}`,
    internalLinkPosition: "pdp:bundle",
    internalLinkType: `pdp:${mainTitle}:${title}`,
    internalLinkZoneName: `pdp:${mainTitle}`,
    internalLinkURL: techFilsLists.join(":"),
    clickInternalLinks: "true",
    modalName: "bundle",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfoBundle)
}

export const bundleBreadCrumbPrintAnalytics = productInfo => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `pdp:${PRODUCT_DETAILS}:${PRINT}`,
    eventMsg: "n/a",
    eventName: `pdp:${PRODUCT_DETAILS}:${PRINT}`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: PRINT,
    internalLinkPosition: "pdp:bundle",
    internalLinkType: `pdp:${PRINT}`,
    internalLinkURL: "n/a",
    internalLinkZoneName: `pdp:${PRODUCT_DETAILS}`,
    modalName: "bundle",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const bundleBreadCrumbShareAnalytics = productInfo => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `pdp:${PRODUCT_DETAILS}:${SHARE}`,
    eventMsg: "n/a",
    eventName: `pdp:${PRODUCT_DETAILS}:${SHARE}`,
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: SHARE,
    internalLinkPosition: "pdp:bundle",
    internalLinkType: `pdp:${SHARE}`,
    internalLinkURL: "n/a",
    internalLinkZoneName: `pdp:${PRODUCT_DETAILS}`,
    modalName: "bundle",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const bundleBreadCrumbEmailAndCopyLinkAnalytics = ({
  productInfo = [],
  link = "",
}) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `pdp:${PRODUCT_DETAILS}:${SHARE}`,
    eventMsg: "n/a",
    eventName: `pdp:${PRODUCT_DETAILS}:${SHARE}`,
    eventStatus: "n/a",
    eventType: "informative",
    internalLinkName: link ? "copy link" : "email a friend",
    internalLinkPosition: "pdp:bundle",
    internalLinkType: `pdp:${SHARE}`,
    internalLinkURL: link || "n/a",
    internalLinkZoneName: `pdp:${PRODUCT_DETAILS}`,
    modalName: "bundle",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const bundleBreadSocialShareAnalytics = ({
  productInfo = [],
  link = "",
  hostname = "",
}) => {
  let linkName = ""
  if (hostname.includes("pinterest")) {
    linkName = "pinterest"
  } else if (hostname.includes("facebook")) {
    linkName = "facebook"
  } else if (hostname.includes("x.com")) {
    linkName = "x"
  } else if (hostname.includes("linkedin")) {
    linkName = "linkedin"
  }
  const eventInfo = {
    clickInternalLinks: "false",
    eventAction: `pdp:${PRODUCT_DETAILS}:${SHARE}`,
    eventMsg: "n/a",
    eventName: `pdp:${PRODUCT_DETAILS}:${SHARE}`,
    eventStatus: "n/a",
    eventType: "informative",
    internalLinkName: linkName,
    internalLinkPosition: "pdp:bundle",
    internalLinkType: `pdp:${SHARE}`,
    internalLinkURL: link || "n/a",
    internalLinkZoneName: `pdp:${PRODUCT_DETAILS}`,
    modalName: "bundle",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfo)
}

export const bundleBreadCrumbAnalytics = ({
  internalLinkName = "",
  link = "",
  productInfoBundle = [],
}) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `pdp:${BREADCRUMB}`,
    eventName: `pdp:${BREADCRUMB}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: sanitizeTextForAnalytics(internalLinkName),
    internalLinkPosition: "pdp:bundle",
    internalLinkType: `pdp:${BREADCRUMB}`,
    internalLinkZoneName: `pdp:${PRODUCT_DETAILS}`,
    internalLinkURL: link
      ? (String(link)?.indexOf("http") === -1 ? window.location.origin : "") +
        link
      : "n/a",
    modalName: "bundle",
  }
  pushAnalyticsObjToDataLayer(eventInfo, productInfoBundle)
}

const pushAnalyticsObjToDataLayer = (eventInfo = {}, productInfo = []) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}

  const event = "cmp:click"

  let eventData = {
    event,
    eventInfo,
    page,
  }

  if (productInfo?.length > 0) {
    eventData = { ...eventData, productInfo: productInfo }
  }

  window.adobeDataLayer.push(eventData)
}
